
import React from 'react';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Link } from 'react-router-dom';

const LogoutLink = (props) => {
    return <Text><Link to="/logout">Odhlásit</Link></Text>;
}

export default LogoutLink;
